<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 id="_idParaDest-1"><a id="_idTextAnchor000"></a>Contents<br/>
<br/></h2>
<div>
<div id="_idContainer004">
<p class="firstcenter"><a href="#/Text/acknowledgments#_idTextAnchor001">Acknowledgments</a></p>
<p class="firstcenter"><a href="#/Text/abbreviations#_idTextAnchor002">Abbreviations</a></p>
<p class="firstcenter"><a href="#/Text/bibletransl#_idTextAnchor003">Bible Translations</a></p>
<p class="firstcenter"><a href="#/Text/commentaryguide#_idTextAnchor004">A Guide to Using This Commentary</a></p>
<p class="firstcenter"><a href="#/Text/genintro#_idTextAnchor005">General Introduction</a></p>
<p class="firstcenter"><a href="#/Text/introduction#_idTextAnchor006">Introduction to 1–2 Samuel, 1–2 Kings, 1–2 Chronicles</a></p>
<p class="firstcenter"><a href="#/Text/1samuel#_idTextAnchor072">Commentary on 1 Samuel</a></p>
<p class="firstcenter"><span href="#/Text/2samuel#_idTextAnchor3462" title="Link target outside of Sample">Commentary on 2 Samuel</span></p>
<p class="firstcenter"><span href="#/Text/1kings#_idTextAnchor4184" title="Link target outside of Sample">Commentary on 1 Kings</span></p>
<p class="firstcenter"><span href="#/Text/2kings#_idTextAnchor4964" title="Link target outside of Sample">Commentary on 2 Kings</span></p>
<p class="firstcenter"><span href="#/Text/1chronicles#_idTextAnchor5755" title="Link target outside of Sample">Commentary on 1 Chronicles</span></p>
<p class="firstcenter"><span href="#/Text/2chronicles#_idTextAnchor6152" title="Link target outside of Sample">Commentary on 2 Chronicles</span></p>
<p class="firstcenter"><span href="#/Text/mapandtimeline#page674" title="Link target outside of Sample">Map of Europe at the Time of the Reformation</span></p>
<p class="firstcenter"><span href="#/Text/mapandtimeline#page675" title="Link target outside of Sample">Timeline of the Reformation</span></p>
<p class="firstcenter"><span href="#/Text/figuresandworks#_idTextAnchor6678" title="Link target outside of Sample">Biographical Sketches of Reformation-Era Figures and Works</span></p>
<p class="firstcenter"><span href="#/Text/sourcesbiosketch#_idTextAnchor6680" title="Link target outside of Sample">Sources for Biographical Sketches</span></p>
<p class="firstcenter"><span href="#/Text/bibliography#_idTextAnchor6681" title="Link target outside of Sample">Bibliography</span></p>
<p class="firstcenter"><span href="#/Text/authorwritingsindex#_idTextAnchor6682" title="Link target outside of Sample">Author and Writings Index</span></p>
<p class="firstcenter"><span href="#/Text/subjectindex#_idTextAnchor6684" title="Link target outside of Sample">Subject Index</span></p>
<p class="firstcenter"><span href="#/Text/scriptureindex#_idTextAnchor6686" title="Link target outside of Sample">Scripture Index</span></p>
<p class="firstcenter"><span href="#/Text/praise#_idTextAnchor6687" title="Link target outside of Sample">Praise for the Reformation Commentary on Scripture</span></p>
<p class="firstcenter"><span href="#/Text/advisers#_idTextAnchor6688" title="Link target outside of Sample">Reformation Commentary on Scripture Board of Advisers</span></p>
<p class="firstcenter"><span href="#/Text/serieseditors#_idTextAnchor6689" title="Link target outside of Sample">Series Editors</span></p>
<p class="firstcenter"><span href="#/Text/volumeeditor#_idTextAnchor6690" title="Link target outside of Sample">Volume Editor</span></p>
<p class="firstcenter"><span href="#/Text/RConS#_idTextAnchor6691" title="Link target outside of Sample">Reformation Commentary on Scripture</span></p>
<p class="firstcenter"><span href="#/Text/textbookselector#_idTextAnchor6692" title="Link target outside of Sample">IVP Academic Textbook Selector</span></p>
<p class="firstcenter"><span href="#/Text/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
<p class="firstcenter"><span class="pagebreak" id="pagexii" title="xii"></span></p>
<p class="body"><span class="pagebreak" id="pagexiii" title="xiii"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a9abeb90